import { requests } from "../config";
import { IGetLstPriceRequest } from "./models/priceRequests";
import { IGetLstPriceResponse } from "./models/priceResponses";

export const Price = {
  getLstPrice: (data: IGetLstPriceRequest): Promise<IGetLstPriceResponse> => requests.get(`price/last_price?CustomerID=${data.CustomerID}&ProductID=${data.ProductID}&VarietyID=${data.VarietyID}&Size=${data.Size}&QualityID=${data.QualityID}&PackID=${data.PackID}`, "go"),
}